module.exports = __webpack_public_path__ + "static/media/app_icon.645f4b6a.png";